export const OPEN_AUDIENCE_TARGETINGS_EDITOR = 'OPEN_AUDIENCE_TARGETINGS_EDITOR';
export type OPEN_AUDIENCE_TARGETINGS_EDITOR = typeof OPEN_AUDIENCE_TARGETINGS_EDITOR;

export interface OpenAudienceTargetingsEditorAction {
    type: OPEN_AUDIENCE_TARGETINGS_EDITOR;
    id: string;
    value: string;
}

export function openAudienceTargetingsEditor(id: string, value: string): OpenAudienceTargetingsEditorAction {
    return {
        type: OPEN_AUDIENCE_TARGETINGS_EDITOR,
        id,
        value
    };
}

export const CLOSE_AUDIENCE_TARGETINGS = 'CLOSE_AUDIENCE_TARGETINGS';
export type CLOSE_AUDIENCE_TARGETINGS = typeof CLOSE_AUDIENCE_TARGETINGS;

export interface CloseAudienceTargetingsAction {
    type: CLOSE_AUDIENCE_TARGETINGS;
    id: string;
    value: string[];
}

export function closeAudienceTargetings(id: string, value: string[]): CloseAudienceTargetingsAction {
    return {
        type: CLOSE_AUDIENCE_TARGETINGS,
        id,
        value
    };
}

export const AUDIENCE_TARGETINGS_TEMPLATE_NAME_CHANGE = 'AUDIENCE_TARGETINGS_TEMPLATE_NAME_CHANGE';
export type AUDIENCE_TARGETINGS_TEMPLATE_NAME_CHANGE = typeof AUDIENCE_TARGETINGS_TEMPLATE_NAME_CHANGE;

export interface AudienceTargetingsTemplateNameChange {
    type: AUDIENCE_TARGETINGS_TEMPLATE_NAME_CHANGE;
    id: string;
    value: string;
}

export function audienceTargetingsTemplateNameChange(id: string, value: string): AudienceTargetingsTemplateNameChange {
    return {
        type: AUDIENCE_TARGETINGS_TEMPLATE_NAME_CHANGE,
        id,
        value
    };
}

export const SAVE_AUDIENCE_TARGETINGS = 'SAVE_AUDIENCE_TARGETINGS';
export type SAVE_AUDIENCE_TARGETINGS = typeof SAVE_AUDIENCE_TARGETINGS;

export interface SaveAudienceTargetings {
    type: SAVE_AUDIENCE_TARGETINGS;
    id: string;
}

export function saveAudienceTargetings(id: string): SaveAudienceTargetings {
    return {
        type: SAVE_AUDIENCE_TARGETINGS,
        id
    };
}

export const RESET_AUDIENCE_TARGETINGS = 'RESET_AUDIENCE_TARGETINGS';
export type RESET_AUDIENCE_TARGETINGS = typeof RESET_AUDIENCE_TARGETINGS;

export interface ResetAudienceTargetings {
    type: RESET_AUDIENCE_TARGETINGS;
    id: string;
}

export function resetAudienceTargetings(id: string): ResetAudienceTargetings {
    return {
        type: RESET_AUDIENCE_TARGETINGS,
        id
    };
}

export type AudienceTargetingsEditorAction =
    | SaveAudienceTargetings
    | ResetAudienceTargetings
    | AudienceTargetingsTemplateNameChange
    | CloseAudienceTargetingsAction
    | OpenAudienceTargetingsEditorAction;
